<template>
    <div class="container">
        <b-modal
            :model-value="modalCrear"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.identificacion }}</label>
                        <b-form-input
                            v-model="form.identificacion"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.digitoVerif }}</label>
                        <b-form-input
                            v-model="form.digitoVerif"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.nombre }}</label>
                        <b-form-input
                            v-model="form.nombre"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.correo }}</label>
                        <b-form-input
                            v-model="form.correo"
                            type="email"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.telefono }}</label>
                        <b-form-input
                            v-model="form.telefono"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.direccion }}</label>
                        <b-form-input
                            v-model="form.direccion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.tipoTercero }}</label>
                        <b-form-select v-model="form.tipoTercero" class="reset-input" autocomplete="off">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="item in listTipoTercero" :key="item.id" :value="item.tipo_tercero">{{ item.descripcion }}</option>
                        </b-form-select>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarTercero()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>

import TipoTerceros from '../../services/TipoTerceros'; 
import Tercero from '../../services/Tercero'; 

export default {
    name:'Crear',
    props:{
        modalCrear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                identificacion : '',
                digitoVerif : '',
                nombre : '',
                correo : '',
                telefono : '',
                direccion : '',
                tipoTercero : '',
            },
            listTipoTercero : []
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear Tercero',
                    save : 'Guardar',
                    close : 'Cerrar',
                    identificacion : 'Identificación',
                    digitoVerif : 'Digito verificación',
                    nombre : 'Nombre',
                    correo : 'Correo',
                    telefono : 'Telefono',
                    direccion : 'Dirección',
                    tipoTercero : 'Tipo tercero',
                    select : 'Seleccione...',
                    formInfoTitle: "Datos del tercero",
                    formInfoSubtitle: "Completa la información y guarda el nuevo tercero." 
                }
            }else{
                return {
                    title : 'Create Third',
                    save : 'Save',
                    close : 'Close',
                    identificacion : 'ID',
                    digitoVerif : 'Verification digit',
                    nombre : 'Name',
                    correo : 'Email',
                    telefono : 'Phone',
                    direccion : 'Address',
                    tipoTercero : 'Tipo tercero',
                    select : 'Select...',
                    formInfoTitle: "Third-party details",
                    formInfoSubtitle: "Complete the information and save the new third party." 
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleanInp();
            this.$emit('cierraModal',false) 
        },
        guardarTercero(){

            if (!this.form.identificacion || !this.form.digitoVerif || !this.form.nombre.trim() || !this.form.correo.trim() || !this.form.telefono.trim() || !this.form.direccion.trim() || !this.form.tipoTercero) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            let info = {
                'identificacion' : this.form.identificacion, 
                'digitoVerificacion' : this.form.digitoVerif, 
                'nombre' : this.form.nombre, 
                'correo' : this.form.correo, 
                'telefono' : this.form.telefono, 
                'direccion' : this.form.direccion, 
                'tipoTercero' : this.form.tipoTercero, 
                'idUser' : this.$store.state.userId 
            }

            Tercero.createTercero(info) 
            .then((res) => { 
                if(res.status == 201){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("creado", res.data.tipoTercero);
                    this.cierraModal();
                
                }else if(res.status == 204){ 
                    this.$toast.error('Tercero ingresado ya existe.') 
                }
            })
            .catch((error) => {
                console.error(error);
                this.$toast.error("Ocurrió un error al guardar.");
            });
        },
        cleanInp(){
            this.form.identificacion = '' 
            this.form.digitoVerif = '' 
            this.form.nombre = '' 
            this.form.correo = '' 
            this.form.telefono = '' 
            this.form.direccion = '' 
            this.form.tipoTercero = ''
        }
    },
    mounted(){
        TipoTerceros.getAllTipoTerceros() 
        .then((res) => { 
            // console.log(res.data.listTipoTerceros); 
            this.listTipoTercero = res.data.listTipoTerceros 
        })
        .catch((error) => {console.log(error)}) 
    }
}
</script>

<style>

</style>
